/* eslint-disable prettier/prettier */
export default [
    {
        rank: '1st',
        prize: 'Trip To Thailand'
    },
    {
        rank: '2nd',
        prize: 'Trip To Goa'
    },
    {
        rank: '3-5',
        prize: '₹10000/-'
    },
    {
        rank: '6-10',
        prize: '₹5000/-'
    },
    {
        rank: '11-20',
        prize: '₹3000/-'
    },
    {
        rank: '21-50',
        prize: '₹2000/-'
    },
    {
        rank: '51-100',
        prize: '₹800/-'
    },
    {
        rank: '101-200',
        prize: '₹450/-'
    },
    {
        rank: '201-300',
        prize: '₹300/-'
    },
    {
        rank: '301-500',
        prize: '₹200/-'
    },
    {
        rank: '501-1000',
        prize: '₹150/-'
    }
];
